import React from 'utils/react';
import useTranslation from 'utils/react/useTranslation';
import { withRouter } from 'react-router-dom';
import { exportGeofence } from 'utils/file';
import { getGeojson } from 'utils/geofences';

import Button from './ButtonMenu';

const DropdownMenu = (props) => {
  const { t } = useTranslation();

  const { geofence, copyGeofence, deleteGeofence, setEditableGeofence } = props;

  const onClone = () => {
    copyGeofence(geofence.key);
  };

  const onDelete = () => {
    deleteGeofence(geofence.key);
  };

  const onEditable = () => {
    setEditableGeofence(geofence);
  };

  const onExport = () => {
    const geojson = getGeojson(geofence.geometry.coordinates);
    const { name } = geofence;
    exportGeofence(JSON.stringify(geojson), name);
  };

  return (
    <React.Fragment>
      <Button onClick={onExport}>
        {t('p.Geofences.Panels.Geofence.Menu.Export')}
      </Button>
      <Button onClick={onEditable}>
        {t('p.Geofences.Panels.Geofence.Menu.Edit')}
      </Button>
      <Button onClick={onClone}>
        {t('p.Geofences.Panels.Geofence.Menu.Clone')}
      </Button>
      <Button onClick={onDelete}>
        {t('p.Geofences.Panels.Geofence.Menu.Delete')}
      </Button>
    </React.Fragment>
  );
};

export default withRouter(DropdownMenu);
